const SELECTOR_HEADER = '.stickyHeader';
const SELECTOR_STICKY = '.stickyHeaderItem';
const VISIBLE_CLASS = 'is-visible';

export default function () {
    const header = document.querySelector(SELECTOR_HEADER);
    const sticky = document.querySelector(SELECTOR_STICKY);

    if (!header || !sticky) {
        return;
    }

    let lastEntry = null;

    const observer = new IntersectionObserver(([ entry ]) => { // eslint-disable-line
        lastEntry = entry;

        sticky.classList.toggle(VISIBLE_CLASS, !entry.isIntersecting);
    });

    const resizeObserver = new ResizeObserver(() => { // eslint-disable-line
        if (!lastEntry) {
            return;
        }

        sticky.classList.toggle(VISIBLE_CLASS, !lastEntry.isIntersecting);
    });

    observer.observe(header);
    resizeObserver.observe(document.documentElement);
}
